export const wizardSteps = [
  {
    step: 'WIZARD_STEP_SELECT_STORAGE',
    title: 'Select your Renderro Plan',
  },
  {
    step: 'WIZARD_STEP_PAYMENT_METHOD',
    title: 'Add your credit card',
  },
]

export type WizardStep = { step: string; title?: string; subtitle?: string }

export function getWizardSteps(hasPayment: boolean): WizardStep[] {
  const steps = [...wizardSteps]
  if (hasPayment) {
    steps.pop()
  }

  return steps
}
